module.exports = __webpack_public_path__ + "static/el-obrero-internacional-7-345d80d38a0ee96fafc2f740ff0c1397.png";